module.exports = __webpack_public_path__ + "static/media/mrgameandwatch_0.5f8eb46a.png";